import React from "react";
import { Moon, Sun } from "lucide-react";
import { useTheme } from "../context/ThemeContext";

export default function ThemeToggle({ className = "" }) {
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === "dark";

  return (
    <button
      type="button"
      onClick={toggleTheme}
      data-testid="theme-toggle"
      aria-label={isDark ? "Switch to light mode" : "Switch to dark mode"}
      className={`inline-flex items-center justify-center w-10 h-10 rounded-md border transition-colors ${
        isDark
          ? "border-white/15 bg-white/5 text-[#9FE3FF] hover:border-[#00C2FF]/50 hover:text-[#00C2FF]"
          : "border-slate-300 bg-white text-[#0077a8] hover:border-[#00C2FF] hover:bg-[#00C2FF]/10"
      } ${className}`}
    >
      {isDark ? <Sun className="w-4 h-4" /> : <Moon className="w-4 h-4" />}
    </button>
  );
}
